export default __webpack_public_path__ + "static/media/our-story_banner.fbf9e5f9.png";